import React, { useState } from 'react'
import PropTypes from 'prop-types'
import TopPanel from './top-panel'
import Pagination from '../pagination'
import League from './league'
import LeagueForm from './forms/league-form'
import FlashAlert from '../../components/flash-alert'

const Leagues = (props) => {
  const [showForm, setShowForm] = useState(null)
  const [alert, setAlert] = useState(null)

  const leaguesList = () => {
    return props.leagues.map((league, index) => {
      return <League {...league} key={index} onEdit={() => setShowForm(league)} />
    })
  }

  const createLeague = (league) => {
    setShowForm(null)
    props.onCreate(league)
    setAlert({ text: 'League created successfully!', type: 'success' })
  }

  const updateLeague = (league) => {
    setShowForm(null)
    props.onUpdate(league)
    setAlert({ text: 'League updated successfully!', type: 'success' })
  }

  return (
    <div className={props.loading ? 'isLoading' : ''}>
      { props.loading && <div className='animated-spinner'></div> }
      { showForm && 
        <LeagueForm 
          id={showForm.id}
          onClose={() => setShowForm(null)}
          onCreate={createLeague}
          onUpdate={updateLeague}
        />
      }
      <TopPanel
        query={props.query}
        onSearch={props.onSearch}
        closed={props.closed}
        onTriggerPast={props.onTriggerPast}
        OnNewLeague={() => setShowForm({})}
      />
      <Pagination 
        page={props.page} 
        perPage={props.per_page}
        totalCount={props.total_count}
        sizes={[8,12,16,20]}
        setPage={props.setPage}
        setPerPage={props.setPerPage}
      />
      <div className='league-date'>Active and Future Leagues</div>
      <div className='row leagues-list'>
        { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
        {leaguesList()}
      </div>
    </div>
  )
}

Leagues.propTypes = {
  leagues: PropTypes.array.isRequired,
  closed: PropTypes.bool.isRequired,
  page: PropTypes.number.isRequired,
  per_page: PropTypes.number.isRequired,
  total_count: PropTypes.number.isRequired,
  query: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  onTriggerPast: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setPerPage: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
}

export default Leagues
